/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Reason_Hr_ThresholdsInputs */

const en_ui_color_by_reason_hr_thresholds = /** @type {(inputs: Ui_Color_By_Reason_Hr_ThresholdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set max & resting HR in your profile`)
};

const de_ui_color_by_reason_hr_thresholds = /** @type {(inputs: Ui_Color_By_Reason_Hr_ThresholdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trag Max- und Ruhepuls in deinem Profil ein`)
};

/**
* | output |
* | --- |
* | "Set max & resting HR in your profile" |
*
* @param {Ui_Color_By_Reason_Hr_ThresholdsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_reason_hr_thresholds = /** @type {((inputs?: Ui_Color_By_Reason_Hr_ThresholdsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Reason_Hr_ThresholdsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_reason_hr_thresholds(inputs)
	return de_ui_color_by_reason_hr_thresholds(inputs)
});